if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // console.log("formData",this.form);
        let formData = new FormData(this.form);
        if(!formData.get("quantity")){
          formData.set("quantity", this.form.querySelector(`[name="quantity"]`).value);
        }
        // for (const pair of formData.entries()) {
        //   console.log(pair[0], pair[1]);
        // }
        
        if (this.cart) {
          formData.append('sections',this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        // check for engraving product / sub product  --- if have then create 2 items arr obj
        // let engraveWrap = this.form.querySelector(".product-single__engraving") || null;
        let subProId = null;
        if(this.form.querySelector(".engraving-btn.active") && this.form.querySelector(".property-fields__rows:not(.hidden)")){
         subProId = this.form.querySelector(".engraving-btn.active").getAttribute("data-engrave-product") || null;
        }
        
        var data = { items: [] };
        var matchFound = $('.product__info-container').hasClass('name-plate');
        if(matchFound){
          var qty_val = parseInt(document.querySelector(`product-info [name="quantity"]`).value);
          
          for (var index = 0; index < qty_val; index++) {
            var random_number = Math.floor(new Date().valueOf() * Math.random());
            var propertyData = jQuery(this.form).serializeArray();
            var ids = '';  
            propertyData.forEach(function(item) {
              if(item.name == 'id'){
                ids = item.value
              }
            });
            var mainproduct = {
              id: ids,
              quantity: 1,
              properties: {
                _Custom_Timestamp: random_number
              }
            };
            $('.line-item-property__field input').each(function(item) {
              // var propertyName = $(this).prev('label').text().trim();
              var propertyValue = $(this).val();
              // console.log(propertyValue);
              // console.log(propertyName);

              let prop = $(this).attr("name").substring(11);
              prop = prop.replace("]","");
              
              // mainproduct.properties[propertyName] = propertyValue;
              mainproduct.properties[prop] = propertyValue;
            });
            console.log("mainproduct",mainproduct);
            data.items.push(mainproduct);
            
            data.sections = this.cart.getSectionsToRender().map((section) => section.id);
            fetch(routes.cart_add_url+'.js', {
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
            
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            
              // if (!this.error)
              //   publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed',() => {
                    setTimeout(() => {this.cart.renderContents(response);});
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
             .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
          }
        
        }else if(!subProId){
          // console.log('else ifffffffffffff',formData);
          config.body = formData;
          // console.log("formData",config.body);
  
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              // console.log("response",response);
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed',() => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });

        }else{

          // console.log('elseeee');
          // engraving pro --- add multiple items at one time
          let itemsArr = [];
          let mainPro = {}; // get main product
          mainPro.id = this.form.querySelector(`[name="id"]`).value;
          mainPro.quantity = this.form.querySelector(`[name="quantity"]`) ? this.form.querySelector(`[name="quantity"]`).value : 1;
        
          let subPro = {}; // get sub product
          subPro.id = this.form.querySelector(".engraving-btn.active").getAttribute("data-engrave-product");
          subPro.quantity = this.form.querySelector(`[name="quantity"]`) ? this.form.querySelector(`[name="quantity"]`).value : 1;

          // get property inputs for sub-product property obj
          let inputProps = this.form.querySelectorAll(`input[name*="properties"]`);
          if(inputProps.length){
            subPro.properties = {};
            inputProps.forEach(input => {
              if(input.value != ""){
                if(input.closest("[data-property-field-item]") && input.closest("[data-property-field-item]").classList.contains("hidden")){
                  return false;
                }
                let prop = input.getAttribute("name").substring(11);
                prop = prop.replace("]","");
                // console.log("prop",prop);
                subPro.properties[prop] = input.value;
              }
            });
          }
          // template :: selected single winner AND league name THEN remove league name
          // console.log("subPro.properties",subPro.properties);
          if(document.querySelector("[data-engraving-league] input")){
            let ln = document.querySelector("[data-engraving-league] input").name.substring(11);
            ln = ln.replace("]","");
            if(document.querySelector(".engraving-btns:not(.hidden)") && document.querySelector("#single-winner-button.active")){
              delete subPro.properties[`${ln}`];
            }
          }
          // console.log("subPro.properties",subPro.properties);
          
          // add timestamp
          var timeStamp = Math.floor(new Date().valueOf() * Math.random()); // for property
          mainPro.properties = {};
          mainPro.properties["Custom_Bundle"] = timeStamp;
          subPro.properties["Custom_Bundle"] = timeStamp;
          subPro.properties["Engrave_product"] = "true";
          // console.log("subPro",subPro);
          itemsArr.push(mainPro);
          itemsArr.push(subPro);
          formData = {items : itemsArr };
          // console.log("formData",formData);
          if (this.cart) {
            formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
            formData.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          // multiple product add to cart
          fetch(routes.cart_add_url+'.js', {
            method: 'POST',
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then((response) => {
            if (response.status) {
              // publish(PUB_SUB_EVENTS.cartError, {
              //   source: 'product-form',
              //   productVariantId: formData.get('id'),
              //   errors: response.errors || response.description,
              //   message: response.message,
              // });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // if (!this.error)
            //   publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed',() => {
                  setTimeout(() => {this.cart.renderContents(response);});
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

        }
        // else end
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}